import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./context/AuthContext";
import { UserAccessProvider } from "context/UserAccessContext";
import { MultiStepFormProvider } from "features/loanApplications/context/MultiStepFormContext";
import { V3App } from "./v3";
import { initRUM } from "./shared/rum";

// Initialize CloudWatch RUM (error tracking, performance, user sessions)
initRUM();

const root = ReactDOM.createRoot(document.getElementById("root")!);

const pathname = window.location.pathname;

if (pathname === "/" || pathname === "") {
  // Root always lands in the V3 experience — it is the only experience.
  // Return before rendering: location.replace() is async, so falling through
  // would briefly mount the whole legacy tree behind the redirect.
  window.location.replace("/v3/");
} else if (pathname.startsWith("/v3")) {
  // V3 has its own BrowserRouter, so render it outside the main app's Router
  root.render(<V3App />);
} else {
  // Legacy V1/V2 routes — still reachable by direct URL, pending removal.
  root.render(
    <Router>
      <AuthProvider>
        <UserAccessProvider>
          <MultiStepFormProvider>
            <App />
          </MultiStepFormProvider>
        </UserAccessProvider>
      </AuthProvider>
    </Router>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
